import template from './index.jst';
import tbc from './tbc.jst';
import TipView from '../Tip';
import './index.styl';

let fin_title = '';

const SQUAD_NICKNAMES = {
	500011: 'broncos',
	500010: 'bulldogs',
	500012: 'cowboys',
	500723: 'dolphins',
	500022: 'dragons',
	500031: 'eels',
	500003: 'knights',
	500014: 'panthers',
	500005: 'rabbitohs',
	500013: 'raiders',
	500001: 'roosters',
	500002: 'sea-eagles',
	500028: 'sharks',
	500021: 'storm',
	500023: 'wests-tigers',
	500004: 'titans',
	500032: 'warriors',
	// Women IDs
	500470: 'broncos',
	500690: 'titans',
	500691: 'knights',
	500692: 'eels',
	500471: 'dragons',
	500469: 'roosters'
}

export class TipFinView extends TipView {
	getTemplate() {
		return this.model.get('status') === 'tbc' ? tbc : template;
	}

	initialize() {
		super.initialize();
		const away_id = this.model.get('away_squad_id'),
			home_id = this.model.get('home_squad_id'),
			round = this.model.get('round') -25,
			home_name = SQUAD_NICKNAMES[home_id],
			away_name = SQUAD_NICKNAMES[away_id]
		let full_match_url =
		`https://www.nrl.com/draw/nrl-premiership/2023/
			finals-week-${round}/${home_name}-v-${away_name}/`

		this.model.set({ 
			full_match_url,
		});
		// SET GRAND FINAL MARGIN
		if(this.model.get('round') === 31){
			this.model.set({
				is_margin_game: true
			})
		}
		this.setFinalTitle();
	}

	setFinalTitle() {
		let is_show_title = false;
		const { round_name } = this.model.attributes;
		if(fin_title !== round_name) {
			is_show_title = true;
			fin_title = round_name;
		}

		this.model.set({ is_show_title });
	}
}

export default TipFinView;